import { RESPONSE_ERROR_KEY, RESPONSE_ERROR_PROBLEM } from "./contants";
import { IErrorDetail } from "./types";

export const getExistErrorKey = (errorDetail: IErrorDetail) => {
  if (errorDetail.problem === RESPONSE_ERROR_PROBLEM.AlreadyExists) {
    return errorDetail.path === "email"
      ? RESPONSE_ERROR_KEY.PrincipalWithEmailAlreadyExists
      : RESPONSE_ERROR_KEY.PrincipalWithUsernameAlreadyExists;
  }

  return RESPONSE_ERROR_KEY.PrincipalWithUsernameAlreadyExists;
};
